import BaseAreaSeries from "./private/BaseAreaSeries.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AreaSeries(props) {
  return /*#__PURE__*/_jsx(BaseAreaSeries, {
    ...props
  });
}